import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { toEnglishNum, toPersianNum } from "../../assets/utils";
import { setLoginMelli } from "../../redux/login/login.actions";
import { selectLoginMelli } from "../../redux/login/login.selectors";

const InputMelli = ({ loginMelli, setLoginMelli }) => {
  const handle_input_change = (e) => {
    const value = e.currentTarget.value;

    setLoginMelli(toEnglishNum(value));
  };

  return (
    <div className="mt-5 my-4 pb-5">
      <div className="font-weight-bold font-size--3 mb-3">
        لطفا کدملی خود را وارد کنید (اختیاری)
      </div>
      <div>
        <input
          onChange={(e) => handle_input_change(e)}
          className="input--custom w-100 font-size--3 text-center"
          style={{ height: "48px" }}
          type="tel"
          name=""
          id=""
          maxLength="10"
          value={toPersianNum(loginMelli)}
        />
      </div>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  loginMelli: selectLoginMelli,
});

const mapDispatchToProps = (dispatch) => ({
  setLoginMelli: (x) => dispatch(setLoginMelli(x)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InputMelli);
